import Vue from "vue";
import {Component, Watch} from "vue-property-decorator";
import "./tableAutomations.styl";
import {Routes} from "../../../router";
import {ConfigService} from "../../../helpers/services/configService";
import {UtilsService} from "../../../helpers/services/utilsService";
import {LanguageManager} from "../../../languages/languages";
import {Automation} from "../../../models/automation";
import {eventBus, signalNames} from "../../../bus";
import * as moment from "moment";
import {application} from "../../../stores/application";
const template = require("./tableAutomations.vue");
interface PaginationObject {
  rowsPerPage: number;
  page: number;
}

@Component({
  template: template
})
export default class TableAutomationsComponent extends Vue {

  automations: any = null;
  search: string = "";
  totalItems = 0;
  pagination: PaginationObject = {
    rowsPerPage: 10,
    page: 1,
  };

  headers = [
    // { text: LanguageManager.instance.i18n.t("automationIndex"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("automationName"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("automationUuid"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("macAddress"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("automationUser"), align: "left", sortable: false },
    { text: LanguageManager.instance.i18n.t("automationUserEmail"), align: "left", sortable: false }
  ];

  @Watch("search")
  searchHandler() {
    
    const { rowsPerPage } = this.pagination;
    const query = `?page=1&per_page=${rowsPerPage}${this.search.length === 0 ? "" : `&q=${encodeURIComponent(this.search)}`}`;
    if (this.search.length > 1) {
      this.refreshAutomations(query);
    } else if (this.search.length === 0) {
      this.refreshAutomations(query);
    }
  }

  @Watch("pagination", { deep: true })
  paginationHandler() {

    const { page, rowsPerPage } = this.pagination;
    const query = `?page=${page}&per_page=${rowsPerPage}${this.search.length === 0 ? "" : `&q=${encodeURIComponent(this.search)}`}`;
    this.refreshAutomations(query);
  }

  created() {

    const { rowsPerPage } = this.pagination;
    const query = `?page=1&per_page=${rowsPerPage}`;
    this.refreshAutomations(query);
    eventBus.$emit(signalNames.setToolbarOptions, {
      title: LanguageManager.instance.i18n.t("automationRequests"),
      reloadAction: () => this.refreshAutomations(query)
    });
  }

  refreshAutomations(query) {
    
    application.commitStartLoader(this.$store);
    // this.automations = null;
    const { page, rowsPerPage } = this.pagination;
    Vue.http.get(ConfigService.automations + query, {})
      .then(response => {
        this.automations = response.data.data.map(automation => new Automation().deserialize(automation).flatten());
        this.totalItems = Number(response.data.metadata.total_count);
        // this.automations.forEach(this.logArrayElements);
        console.log("automation: ", this.automations);
        application.commitStopLoader(this.$store);
      })
      .catch(error => {
        application.commitStopLoader(this.$store);
        eventBus.$emit(signalNames.showError);
      });
  }

  // logArrayElements(element, index, array) {
  //   element.index = index;
  // }

  customSort(automations: Automation[]): Automation[] {
    const pending = [];
    const attending = [];
    const rejected = [];
    const others = [];
    // automations.forEach(automation => {
    //   switch (automation.state) {
    //     case "pending":
    //       pending.push(automation);
    //       break;
    //     case "accepted":
    //       attending.push(automation);
    //       break;
    //     case "cancelled":
    //       rejected.push(automation);
    //       break;
    //     default:
    //       others.push(automation);
    //   }
    // });
    return pending.sort(this.orderByDate)
      .concat(attending.sort(this.orderByDate))
      .concat(rejected.sort(this.orderByDate))
      .concat(others.sort(this.orderByDate));
  }

  orderByDate(res1, res2): number {
    const d1 = moment(res1.date_from + " " + res1.time_from);
    const d2 = moment(res2.date_from + " " + res2.time_from);
    if (d1 > d2) {
      return 1;
    }
    if (d1 < d2) {
      return -1;
    }
    return 0;
  }

  handleClickAutomation(autoId) {
    // console.log("ECCOMI");
    this.$router.push({name: Routes.automationDetail.name,  params: { id: autoId }});
  }

  getDescriptionFromDateTime(date: string, time: string): string {
    return UtilsService.instance.getDescriptionFromDateTime(date, time);
  }
  getAvatar(rawVehicle: any): string {
    // const vehicle = new Vehicle().deserialize(rawVehicle);
    // return vehicle.getPicture();
    return "";
  }

}

Vue.component("cmTableAutomations", TableAutomationsComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/plain/tableAutomations/tableAutomations.ts